var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedkit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medkit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 3C8.05109 3 7.86032 3.07902 7.71967 3.21967C7.57902 3.36032 7.5 3.55109 7.5 3.75V4.5H16.5V3.75C16.5 3.55109 16.421 3.36032 16.2803 3.21967C16.1397 3.07902 15.9489 3 15.75 3H8.25ZM18 4.5V3.75C18 3.15326 17.7629 2.58097 17.341 2.15901C16.919 1.73705 16.3467 1.5 15.75 1.5H8.25C7.65326 1.5 7.08097 1.73705 6.65901 2.15901C6.23705 2.58097 6 3.15326 6 3.75V4.5H3.75C2.09315 4.5 0.75 5.84315 0.75 7.5V19.5C0.75 21.1569 2.09315 22.5 3.75 22.5H20.25C21.9069 22.5 23.25 21.1569 23.25 19.5V7.5C23.25 5.84315 21.9069 4.5 20.25 4.5H18ZM3.75 6C2.92157 6 2.25 6.67157 2.25 7.5V19.5C2.25 20.3284 2.92157 21 3.75 21H20.25C21.0784 21 21.75 20.3284 21.75 19.5V7.5C21.75 6.67157 21.0784 6 20.25 6H3.75ZM12 9C12.4142 9 12.75 9.33579 12.75 9.75V12.75H15.75C16.1642 12.75 16.5 13.0858 16.5 13.5C16.5 13.9142 16.1642 14.25 15.75 14.25H12.75V17.25C12.75 17.6642 12.4142 18 12 18C11.5858 18 11.25 17.6642 11.25 17.25V14.25H8.25C7.83579 14.25 7.5 13.9142 7.5 13.5C7.5 13.0858 7.83579 12.75 8.25 12.75H11.25V9.75C11.25 9.33579 11.5858 9 12 9Z",
    fill: "#667E87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedkit);
export default __webpack_public_path__ + "static/media/medkit.0e3bec585168548a34c6ac57a2197df1.svg";
export { ForwardRef as ReactComponent };